import { createAsyncThunk } from "@reduxjs/toolkit";
import * as authApi from "../../api/requests/auth";
import * as profileApi from "../../api/requests/profile";

export const signIn = createAsyncThunk(
  "currentProfile/signIn",
  async (formData) => {
    try {
      const response = await authApi.signin(formData);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const signUp = createAsyncThunk(
  "currentProfile/signUp",
  async (formData) => {
    try {
      const response = await authApi.signup(formData);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const signOut = createAsyncThunk("currentProfile/signOut", async () => {
  try {
    const response = await authApi.signout();
    return response;
  } catch (error) {
    return error;
  }
});

export const getCurrentProfile = createAsyncThunk(
  "currentProfile/getCurrentProfile",
  async () => {
    try {
      const response = await profileApi.getCurrentProfile();
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const addBookmark = createAsyncThunk(
  "currentProfile/addBookmark",
  async (postId) => {
    try {
      const response = await profileApi.addBookmark(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const removeBookmark = createAsyncThunk(
  "currentProfile/removeBookmark",
  async (postId) => {
    try {
      const response = await profileApi.removeBookmark(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const editProfile = createAsyncThunk(
  "currentProfile/editProfile",
  async (formData) => {
    try {
      const response = await profileApi.updateProfile(formData);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const uploadAvatar = createAsyncThunk(
  "currentProfile/uploadAvatar",
  async (formData) => {
    try {
      const response = await profileApi.uploadAvatar(formData);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const uploadBanner = createAsyncThunk(
  "currentProfile/uploadBanner",
  async (formData) => {
    try {
      const response = await profileApi.uploadBanner(formData);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getBookmarks = createAsyncThunk(
  "currentProfile/getBookmarks",
  async () => {
    try {
      const response = await profileApi.getBookmarks();
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const updateFollowing = createAsyncThunk(
  "currentProfile/updateFollowing",
  async (args) => {
    return args;
  },
);

export const verifyEmail = createAsyncThunk(
  "currentProfile/verifyEmail",
  async (token) => {
    try {
      const response = await profileApi.verifyEmail(token);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const markNotificationsRead = createAsyncThunk(
  "currentProfile/markNotificationsRead",
  async () => {
    try {
      const response = await profileApi.markNotificationsRead();
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const deleteCurrentProfile = createAsyncThunk(
  "currentProfile/deleteCurrentProfile",
  async (password) => {
    try {
      const response = await profileApi.deleteMe(password);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const updateCurrentUsername = createAsyncThunk(
  "currentProfile/updateCurrentUsername",
  async (username) => {
    try {
      const response = await profileApi.updateUsername(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);
